import {
  GET_USER_TOKEN_GETTER,
  IS_USER_AUTHENTICATED_GETTER,
  GET_USER_LEVEL_GETTER,
  GET_USER_ID_GETTER,
  GET_USER_NAME_GETTER,
  GET_USER_AVATAR_GETTER,
  GET_USER_EMAIL_GETTER,
  GET_EDITION_GETTER,
  GET_IDTOCANCEL_GETTER,
  GET_FRRID_GETTER,
  GET_TEAMACTIONS_GETTER,
  GET_ACTIONSLEVEL_GETTER,
  GET_PROJECTFRR_GETTER,
  GET_PROJECTTR_GETTER,
  GET_CLOSEDTR_GETTER,
  GET_CLOSEDFRR_GETTER,
  //GET_FRRDESCRIPTION_GETTER,
  GET_SECTION_GETTER,
  GET_TEBID_GETTER,
  GET_TEBNAME_GETTER,
  GET_TRDETAILS_GETTER,
  GET_TRID_GETTER,
  GET_TROBSERVATIONS_GETTER,
  GET_TEAMNUMBER_GETTER,
  GET_PLID_GETTER,
  GET_CLOSEDPL_GETTER,
  GET_PROJECTPL_GETTER,
  GET_PLOBSERVATIONS_GETTER,
  GET_VDID_GETTER,
  GET_CLOSEDVD_GETTER,
  GET_PROJECTVD_GETTER,
  GET_VDOBSERVATIONS_GETTER,
  GET_FPID_GETTER,
  GET_CLOSEDFP_GETTER,
  GET_PROJECTFP_GETTER,
  GET_FPOBSERVATIONS_GETTER,
  GET_APOGEE_GETTER,
  GET_ID_GETTER,
  GET_CLOSED_GETTER,
  GET_OBSERVATIONS_GETTER,
  GET_PROJECT_GETTER,
  GET_USER_LEVELNAME_GETTER,
  GET_ACTIONSCOMPLETE_GETTER,
} from "../../storeconstants";

export default {
  [GET_USER_TOKEN_GETTER]: (state) => {
    return state.token;
  },
  [IS_USER_AUTHENTICATED_GETTER]: (state) => {
    return !!state.token;
  },
  [GET_USER_LEVEL_GETTER]: (state) => {
    return state.levelID;
  },
  [GET_USER_LEVELNAME_GETTER]: (state) => {
    return state.level;
  },
  [GET_USER_ID_GETTER]: (state) => {
    return state.userID;
  },
  [GET_USER_NAME_GETTER]: (state) => {
    let name = state.firstname + " " + state.lastname;
    return name;
  },
  [GET_USER_AVATAR_GETTER]: (state) => {
    return state.img;
  },
  [GET_USER_EMAIL_GETTER]: (state) => {
    return state.email;
  },
  [GET_EDITION_GETTER]: (state) => {
    return state.edition;
  },
  [GET_IDTOCANCEL_GETTER]: (state) => {
    return state.idtocancel;
  },
  [GET_FRRID_GETTER]: (state) => {
    return state.frrID;
  },
  //TR
  [GET_TRID_GETTER]: (state) => {
    return state.trID;
  },
  [GET_CLOSEDTR_GETTER]: (state) => {
    return state.closedTR;
  },
  [GET_PROJECTTR_GETTER]: (state) => {
    return state.projectTR;
  },
  //PL
  [GET_PLID_GETTER]: (state) => {
    return state.payloadID;
  },
  [GET_CLOSEDPL_GETTER]: (state) => {
    return state.closedPL;
  },
  [GET_PROJECTPL_GETTER]: (state) => {
    return state.projectPL;
  },
  [GET_PLOBSERVATIONS_GETTER]: (state) => {
    return state.observationsPL;
  },
  //VD
  [GET_VDID_GETTER]: (state) => {
    return state.designID;
  },
  [GET_CLOSEDVD_GETTER]: (state) => {
    return state.closedVD;
  },
  [GET_PROJECTVD_GETTER]: (state) => {
    return state.projectVD;
  },
  [GET_VDOBSERVATIONS_GETTER]: (state) => {
    return state.observationsVD;
  },
  //FP
  [GET_FPID_GETTER]: (state) => {
    return state.flightID;
  },
  [GET_CLOSEDFP_GETTER]: (state) => {
    return state.closedFP;
  },
  [GET_PROJECTFP_GETTER]: (state) => {
    return state.projectFP;
  },
  [GET_FPOBSERVATIONS_GETTER]: (state) => {
    return state.observationsFP;
  },
  [GET_APOGEE_GETTER]: (state) => {
    return state.apogee;
  },
  //FRR
  [GET_PROJECTFRR_GETTER]: (state) => {
    return state.projectFRR;
  },
  [GET_CLOSEDFRR_GETTER]: (state) => {
    return state.closedFRR;
  },
  [GET_TEAMACTIONS_GETTER]: (state) => {
    return state.teamactions;
  },
  [GET_ACTIONSLEVEL_GETTER]: (state) => {
    return state.actionslevel;
  },
  [GET_ACTIONSCOMPLETE_GETTER]: (state) => {
    return state.actionscomplete;
  },
  [GET_TROBSERVATIONS_GETTER]: (state) => {
    return state.observationsTR;
  },
  [GET_SECTION_GETTER]: (state) => {
    return state.FRRsection;
  },
  [GET_TEBID_GETTER]: (state) => {
    return state.tebID;
  },
  [GET_TEBNAME_GETTER]: (state) => {
    return state.tebName;
  },
  [GET_TRDETAILS_GETTER]: (state) => {
    return state.trdetail;
  },

  //teste
  [GET_ID_GETTER]: (state) => {
    return state.id;
  },
  [GET_CLOSED_GETTER]: (state) => {
    return state.closed;
  },
  [GET_PROJECT_GETTER]: (state) => {
    return state.project;
  },
  [GET_OBSERVATIONS_GETTER]: (state) => {
    return state.observations;
  },
};
